import { useRouter } from 'next/navigation';
import { Checkbox, TableCell, TableRow } from '@mui/material';

import { ProcessedName, StyledIdTableCell } from '~/shared';
import { CampaignReport } from '~/types';

// import { useDownloadReportsCampaign } from '../../hooks';

export type ReportCampaignsRowProps = {
  advertiserId: string;
  resume: CampaignReport;
  isSelected: boolean;
  onSelect: (selected: boolean) => void;
};

export function ReportCampaignsRow({
  resume,
  advertiserId,
  isSelected,
  onSelect,
}: ReportCampaignsRowProps) {
  const router = useRouter();

  function handleClick() {
    router.push(`/relatorios/${advertiserId}/${resume.idCampaign}`);
  }

  // const downloadReportsCampaignMutation = useDownloadReportsCampaign(res => {
  //   const nowFormatted = format(new Date(), 'dd-MM-yyyy HH-mm');
  //   const filename = `Relatório Campanha - ${resume.nameCampaign ?? 'Sem Nome'} - ${nowFormatted}.xlsx`;
  //   const blob = new Blob([res.data], { type: res.headers['content-type'] });
  //   const downloadUrl = window.URL.createObjectURL(blob);
  //   const a = document.createElement('a');
  //   a.href = downloadUrl;
  //   a.download = filename;
  //   a.click();
  // });

  // function handleExportExcel() {
  //   downloadReportsCampaignMutation.mutate({
  //     idCampaign: resume.idCampaign,
  //     count: 9999,
  //     page: 1,
  //   });
  // }

  const getPlatformLabel = ({
    isApp,
    isWeb,
  }: Pick<CampaignReport, 'isApp' | 'isWeb'>) => {
    const appLabel = isApp ? 'App' : '';
    const webLabel = isWeb ? 'Web' : '';

    if (appLabel && webLabel) {
      return `${appLabel}/${webLabel}`;
    }
    if (appLabel || webLabel) {
      return `${appLabel}${webLabel}`;
    }
    return '-';
  };

  return (
    <TableRow
      key={resume.idCampaign}
      sx={{
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        '&:hover': {
          '.MuiTableCell-body': {
            backgroundColor: theme => theme.palette.grey[100],
          },
        },
        '.MuiTableCell-body': {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <TableCell align="center" onClick={e => e.stopPropagation()}>
        <Checkbox
          checked={isSelected}
          onChange={e => onSelect(e.target.checked)}
        />
      </TableCell>

      <StyledIdTableCell
        component="th"
        scope="row"
        align="center"
        onClick={handleClick}
      >
        {resume.idCampaign}
      </StyledIdTableCell>
      <TableCell
        component="th"
        scope="row"
        sx={{ position: 'sticky', left: 0 }}
        onClick={handleClick}
      >
        <ProcessedName name={resume.nameCampaign} />
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {getPlatformLabel(resume)}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.impressions ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.clicks ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.ctr ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.cpm ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.cpc ?? '-'}
      </TableCell>
      {/* <TableCell component="th" scope="row" align="center">
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ textTransform: 'none' }}
          startIcon={
            downloadReportsCampaignMutation.isPending ? (
              <CircularProgress size={15} />
            ) : (
              <SaveAltSharp />
            )
          }
          onClick={handleExportExcel}
          disabled={downloadReportsCampaignMutation.isPending}
        >
          Baixar
        </Button>
      </TableCell> */}
    </TableRow>
  );
}
